// extracted by mini-css-extract-plugin
export default {"container":"PopupDownRename_container__RNju+","input":"PopupDownRename_input__24u7A","buttons":"PopupDownRename_buttons__xzR3B"};